export const SOPS = {
  tabDuring: 'sops-tab-during',
  tabAfter: 'sops-tab-after',
  tabResources: 'sops-tab-resources',
  item: (id) => `sops-item-${id}`,
};

export const RESOURCES = {
  comingSoonBanner: 'resources-coming-soon-banner',
  emergencyNote: 'resources-emergency-note',
  category: (key) => `resources-category-${key}`,
};

export const VOLUNTEER = {
  section: 'volunteer-section',
  nameInput: 'volunteer-name-input',
  emailInput: 'volunteer-email-input',
  phoneInput: 'volunteer-phone-input',
  locationInput: 'volunteer-location-input',
  professionInput: 'volunteer-profession-input',
  helpTypeCheckbox: (key) => `volunteer-help-type-${key}`,
  messageInput: 'volunteer-message-input',
  submitButton: 'volunteer-submit-button',
  successMessage: 'volunteer-success-message',
};

export const FRAMEWORK = {
  levelCard: (level) => `framework-level-card-${level}`,
};

export const DASHBOARD = {
  myScenariosTab: 'dashboard-tab-scenarios',
  myIncidentsTab: 'dashboard-tab-incidents',
};

export const ADMIN = {
  incidentsTable: 'admin-incidents-table',
};
